import axios from "axios";
import { BASE_URL } from "./apiconfig";

export const getAllFirmware = async (token: string | null, params:string) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/developer/firmware?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    } catch (error) {
      console.log("Failed to pull all firmware. ", error);
      throw error;
    }
}

export const getAvailableFirmware = async (token: string | null, params:string) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/firmware/available?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    } catch (error) {
      console.log("Failed to pull firmware available. ", error);
      throw error;
    }
}

export const getAvailableDevFirmware = async (token: string | null, params:string) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/developer/firmware/dev?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return data;
    } catch (error) {
      console.log("Failed to pull dev firmware available. ", error);
      throw error;
    }
}

export const getAvailableAdminFirmware = async (token: string | null, params:string) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/admin/firmware/admin?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return data;
    } catch (error) {
      console.log("Failed to pull admin firmware available. ", error);
      throw error;
    }
}

export const upgradeFirmwareApi = async (token: string | null, firmwareInfo : {spa_id: string,platform: string,version: string, ignoreSame?: boolean}) => {
  try {
      const response = await axios.post(`${BASE_URL}/firmware/upgrade`, 
        {...firmwareInfo, 
            source: "web_portal"
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        });

      return response.data;
  } catch (error) {
        console.log("Failed to upgrade spa. ", error);
      throw error;
  }
};

export const bulkUpgradeFirmwareApi = async (token: string | null, firmwareInfo: {spa_guids: string[], platform: string, version: string}) => {
  try {
      const response = await axios.post(`${BASE_URL}/firmware/bulk-upgrade`, 
        firmwareInfo,
        {
          headers: { Authorization: `Bearer ${token}` }
        });

      return response.data;
  } catch (error) {
        console.log("Failed to bulk upgrade spas. ", error);
      throw error;
  }
};

export const uploadFirmwareApi = async (token: string | null, formData: FormData) => {
    try {
        const {data} = await axios.post(`${BASE_URL}/developer/firmware/upload`,formData,{
            headers: { 
                Authorization: `Bearer ${token}` ,
            },
        });

        return data
    } catch (error) {
        console.log("Failed upload firmware.", error);
        throw error;
    }
}


export const updateFirmwareApi = async (token: string | null, firmwareInfo: {firmware_id: string, is_latest?: boolean, description?: string, is_dev?: boolean, is_admin?: boolean}) => {
    try {
        const {data} = await axios.put(`${BASE_URL}/developer/firmware/${firmwareInfo.firmware_id}`,
            firmwareInfo
            ,{
            headers: { 
                Authorization: `Bearer ${token}` ,
            },
        });

        return data
    } catch (error) {
        console.log("Failed to update firmware information.", error);
        throw error;
    }
}

export const deleteFirmwareApi = async (token: string | null, firmware_id: string) => {
    try {
        const {data} = await axios.delete(`${BASE_URL}/developer/firmware/${firmware_id}`,{
            headers: { 
                Authorization: `Bearer ${token}` ,
            },
        });

        return data
    } catch (error) {
        console.log("Failed to delete firmware.", error);
        throw error;
    }
}

export const downloadFirmwareFile = async (token: string | null, firmware_id: number) => {
    try {
        const {data} = await axios.post(`${BASE_URL}/developer/firmware/download/${firmware_id}`,{},{
            headers: { Authorization: `Bearer ${token}` },
        });

        return data
    } catch (error) {
        console.log("Failed to download firmware file. ", error);
        throw error;
    }
}

export const getUploadUrl = async (token: string, firmwareInfo: {
    type: string;
    version: string;
    description: string;
    contentType: string;
    fileName: string;
    is_latest: boolean;
    is_dev: boolean;
    is_admin: boolean;
}) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/developer/firmware/upload-url`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                ...firmwareInfo,
                is_latest: firmwareInfo.is_latest ? 1 : 0,
                is_dev: firmwareInfo.is_dev ? 1 : 0,
                is_admin: firmwareInfo.is_admin ? 1 : 0,
            }
        });
        return data;
    } catch (error) {
        console.error('Error getting upload URL:', error);
        throw error;
    }
};

export const confirmUpload = async (token: string, confirmData: {
    status: 'completed' | 'failed';
    type: string;
    version: string;
    description: string;
    is_latest: boolean;
    is_dev: boolean;
    is_admin: boolean;
    s3Key: string;
}) => {
    try {
        const {data} = await axios.post(`${BASE_URL}/developer/firmware/confirm`, confirmData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return data;
    } catch (error) {
        console.error('Error confirming upload:', error);
        throw error;
    }
};


